package music.jammers.client.shared.auth.data.repository

import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.Settings
import com.russhwolf.settings.serialization.decodeValueOrNull
import com.russhwolf.settings.serialization.encodeValue
import com.russhwolf.settings.serialization.removeValue
import kotlinx.serialization.ExperimentalSerializationApi
import music.jammers.client.shared.auth.domain.repository.TokenRepository
import music.jammers.shared.auth.domain.model.Token

@OptIn(ExperimentalSerializationApi::class, ExperimentalSettingsApi::class)
internal class TokenRepositoryImpl(
    private val settings: Settings,
) : TokenRepository {

    override fun save(token: Token) {
        settings.encodeValue(Token.serializer(), TOKEN_KEY, token)
    }

    override fun get(): Token? =
        settings.decodeValueOrNull(Token.serializer(), TOKEN_KEY)

    override fun clear() {
        settings.removeValue(Token.serializer(), TOKEN_KEY)
    }

    private companion object {

        const val TOKEN_KEY = "KEY_AUTH_TOKEN"
    }
}